module.exports = [
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits before a tag toggles to it's edit mode",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 45,
                  "offset": 44
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 45,
              "offset": 44
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 45,
          "offset": 44
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits before a tag toggles to it's edit mode",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 2,
        "name": "before-editing-tag"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": "hook"
      },
      {
        "title": "returns",
        "description": "Contains the to editing tag: 'tag'.\nThe tag's index: 'index'. And a function: 'editTag'.\nIf the function is invoked, the tag toggles to it's edit mode.",
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 90,
        "column": 6
      },
      "end": {
        "line": 97,
        "column": 9
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 98,
          "column": 6
        },
        "end": {
          "line": 102,
          "column": 9
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [
      {
        "title": "property",
        "name": "hook",
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        }
      }
    ],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "Contains the to editing tag: 'tag'.\nThe tag's index: 'index'. And a function: 'editTag'.\nIf the function is invoked, the tag toggles to it's edit mode.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 3,
                      "column": 63,
                      "offset": 151
                    },
                    "indent": [
                      1,
                      1
                    ]
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 63,
                  "offset": 151
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 63,
              "offset": 151
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "before-editing-tag",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "before-editing-tag"
      }
    ],
    "namespace": "before-editing-tag"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits before a tag is deleted",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 30,
                  "offset": 29
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 30,
              "offset": 29
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 30,
          "offset": 29
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits before a tag is deleted",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 2,
        "name": "before-deleting-tag"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": "hook"
      },
      {
        "title": "returns",
        "description": "Contains the to editing tag: 'tag'. The tag's index: 'index'\nAnd a function: 'deleteTag'. If the function is invoked, the tag is deleted.",
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 161,
        "column": 6
      },
      "end": {
        "line": 167,
        "column": 9
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 168,
          "column": 6
        },
        "end": {
          "line": 172,
          "column": 9
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [
      {
        "title": "property",
        "name": "hook",
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        }
      }
    ],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "Contains the to editing tag: 'tag'. The tag's index: 'index'\nAnd a function: 'deleteTag'. If the function is invoked, the tag is deleted.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 2,
                      "column": 77,
                      "offset": 137
                    },
                    "indent": [
                      1
                    ]
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 77,
                  "offset": 137
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 77,
              "offset": 137
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "before-deleting-tag",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "before-deleting-tag"
      }
    ],
    "namespace": "before-deleting-tag"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits if the tags array changes",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 32,
                  "offset": 31
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 32,
              "offset": 31
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 32,
          "offset": 31
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits if the tags array changes",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 2,
        "name": "tags-changed"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "returns",
        "description": "The modified tags array",
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 185,
        "column": 6
      },
      "end": {
        "line": 190,
        "column": 9
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 191,
          "column": 6
        },
        "end": {
          "line": 191,
          "column": 48
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The modified tags array",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 24,
                      "offset": 23
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 24,
                  "offset": 23
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 24,
              "offset": 23
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "tags-changed",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "tags-changed"
      }
    ],
    "namespace": "tags-changed"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits before a tag is added",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 28,
                  "offset": 27
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 28,
              "offset": 27
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 28,
          "offset": 27
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits before a tag is added",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 2,
        "name": "before-adding-tag"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": "hook"
      },
      {
        "title": "returns",
        "description": "Contains the to editing tag: 'tag'. And a function: 'addTag'.\nIf the function is invoked, the tag is added.",
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 217,
        "column": 8
      },
      "end": {
        "line": 223,
        "column": 11
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 224,
          "column": 8
        },
        "end": {
          "line": 227,
          "column": 11
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [
      {
        "title": "property",
        "name": "hook",
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        }
      }
    ],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "Contains the to editing tag: 'tag'. And a function: 'addTag'.\nIf the function is invoked, the tag is added.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 2,
                      "column": 46,
                      "offset": 107
                    },
                    "indent": [
                      1
                    ]
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 46,
                  "offset": 107
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 46,
              "offset": 107
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "before-adding-tag",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "before-adding-tag"
      }
    ],
    "namespace": "before-adding-tag"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits if the maximum, the tags array is allowed to hold, is reached.\nThe maximum can be defined by the prop 'max-tags'.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 51,
                  "offset": 119
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 51,
              "offset": 119
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 51,
          "offset": 119
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits if the maximum, the tags array is allowed to hold, is reached.\nThe maximum can be defined by the prop 'max-tags'.",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 3,
        "name": "max-tags-reached"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "returns",
        "description": "The 'tag' which could not be added because of the length limitation.",
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 247,
        "column": 8
      },
      "end": {
        "line": 253,
        "column": 11
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 254,
          "column": 8
        },
        "end": {
          "line": 254,
          "column": 71
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The 'tag' which could not be added because of the length limitation.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 69,
                      "offset": 68
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 69,
                  "offset": 68
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 69,
              "offset": 68
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "max-tags-reached",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "max-tags-reached"
      }
    ],
    "namespace": "max-tags-reached"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits if the user tries to add a duplicate to the tag's array\nand adding duplicates is prevented by the prop 'avoid-adding-duplicates'",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 73,
                  "offset": 134
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 73,
              "offset": 134
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 73,
          "offset": 134
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits if the user tries to add a duplicate to the tag's array\nand adding duplicates is prevented by the prop 'avoid-adding-duplicates'",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 3,
        "name": "adding-duplicate"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      }
    ],
    "loc": {
      "start": {
        "line": 258,
        "column": 8
      },
      "end": {
        "line": 263,
        "column": 11
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 264,
          "column": 8
        },
        "end": {
          "line": 264,
          "column": 60
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "adding-duplicate",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "adding-duplicate"
      }
    ],
    "namespace": "adding-duplicate"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits before a tag is saved",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 28,
                  "offset": 27
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 28,
              "offset": 27
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 28,
          "offset": 27
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits before a tag is saved",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 2,
        "name": "before-saving-tag"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": "hook"
      },
      {
        "title": "returns",
        "description": "Contains the to editing tag: 'tag'.\nThe tag's index: 'index'. And a function: 'saveTag'.\nIf the function is invoked, the tag is saved.",
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 294,
        "column": 6
      },
      "end": {
        "line": 301,
        "column": 9
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 302,
          "column": 6
        },
        "end": {
          "line": 306,
          "column": 9
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [
      {
        "title": "property",
        "name": "hook",
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "events"
        }
      }
    ],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "Contains the to editing tag: 'tag'.\nThe tag's index: 'index'. And a function: 'saveTag'.\nIf the function is invoked, the tag is saved.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 3,
                      "column": 46,
                      "offset": 134
                    },
                    "indent": [
                      1,
                      1
                    ]
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 46,
                  "offset": 134
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 46,
              "offset": 134
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "before-saving-tag",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "before-saving-tag"
      }
    ],
    "namespace": "before-saving-tag"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Emits if the user tries to save a duplicate in the tag's array\nand saving duplicates is prevented by the prop 'avoid-adding-duplicates'",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 73,
                  "offset": 135
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 73,
              "offset": 135
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 73,
          "offset": 135
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Emits if the user tries to save a duplicate in the tag's array\nand saving duplicates is prevented by the prop 'avoid-adding-duplicates'",
        "lineNumber": 1
      },
      {
        "title": "name",
        "description": null,
        "lineNumber": 3,
        "name": "saving-duplicate"
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "events"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      }
    ],
    "loc": {
      "start": {
        "line": 317,
        "column": 8
      },
      "end": {
        "line": 322,
        "column": 11
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 323,
          "column": 8
        },
        "end": {
          "line": 323,
          "column": 60
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "saving-duplicate",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "saving-duplicate"
      }
    ],
    "namespace": "saving-duplicate"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Create one tag out of a String or validate an existing one",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 59,
                  "offset": 58
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 59,
              "offset": 58
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 59,
          "offset": 58
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Create one tag out of a String or validate an existing one",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "helpers"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "param",
        "description": "A tag which should be validated | A String to create a tag",
        "lineNumber": 3,
        "type": {
          "type": "UnionType",
          "elements": [
            {
              "type": "NameExpression",
              "name": "Object"
            },
            {
              "type": "NameExpression",
              "name": "String"
            }
          ]
        },
        "name": "tag"
      },
      {
        "title": "param",
        "description": "The tags array",
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        },
        "name": "tagsarray"
      },
      {
        "title": "param",
        "description": "The validation Array is optional (pass it if you use one)",
        "lineNumber": 5,
        "type": {
          "type": "OptionalType",
          "expression": {
            "type": "NameExpression",
            "name": "Array"
          }
        },
        "name": "validation",
        "default": "[]"
      },
      {
        "title": "returns",
        "description": "The created (validated) tag",
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 53,
        "column": 0
      },
      "end": {
        "line": 60,
        "column": 3
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 61,
          "column": 0
        },
        "end": {
          "line": 71,
          "column": 2
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/create-tags.js"
    },
    "augments": [],
    "examples": [],
    "params": [
      {
        "title": "param",
        "name": "tag",
        "lineNumber": 3,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "A tag which should be validated | A String to create a tag",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 59,
                      "offset": 58
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 59,
                  "offset": 58
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 59,
              "offset": 58
            }
          }
        },
        "type": {
          "type": "UnionType",
          "elements": [
            {
              "type": "NameExpression",
              "name": "Object"
            },
            {
              "type": "NameExpression",
              "name": "String"
            }
          ]
        }
      },
      {
        "title": "param",
        "name": "rest",
        "lineNumber": 61,
        "type": {
          "type": "RestType"
        }
      },
      {
        "title": "param",
        "name": "tagsarray",
        "lineNumber": 4,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The tags array",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 15,
                      "offset": 14
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 15,
                  "offset": 14
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 15,
              "offset": 14
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "param",
        "name": "validation",
        "lineNumber": 5,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The validation Array is optional (pass it if you use one)",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 58,
                      "offset": 57
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 58,
                  "offset": 57
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 58,
              "offset": 57
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Array"
        },
        "default": "[]"
      }
    ],
    "properties": [],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The created (validated) tag",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 28,
                      "offset": 27
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 28,
                  "offset": 27
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 28,
              "offset": 27
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "createTag",
    "kind": "constant",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "createTag",
        "kind": "constant"
      }
    ],
    "namespace": "createTag"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Create multiple tags out of Strings or validate existing tags",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 62,
                  "offset": 61
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 62,
              "offset": 61
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 62,
          "offset": 61
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Create multiple tags out of Strings or validate existing tags",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "helpers"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "param",
        "description": "An Array containing tags or strings. See example below.",
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        },
        "name": "tagsarray"
      },
      {
        "title": "param",
        "description": "The validation Array is optional (pass it if you use one)",
        "lineNumber": 4,
        "type": {
          "type": "OptionalType",
          "expression": {
            "type": "NameExpression",
            "name": "Array"
          }
        },
        "name": "validation",
        "default": "[]"
      },
      {
        "title": "returns",
        "description": "An array containing (validated) tags",
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "example",
        "description": "&#47;* Example to call the function *&#47;\nconst validatedTags = createTags(['tag1Text', 'tag2Text'], [{ type: 'length', rule: /[0-9]/ }])",
        "lineNumber": 6
      }
    ],
    "loc": {
      "start": {
        "line": 73,
        "column": 0
      },
      "end": {
        "line": 81,
        "column": 3
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 82,
          "column": 0
        },
        "end": {
          "line": 82,
          "column": 81
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/create-tags.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "&#47;* Example to call the function *&#47;\nconst validatedTags = createTags(['tag1Text', 'tag2Text'], [{ type: 'length', rule: /[0-9]/ }])"
      }
    ],
    "params": [
      {
        "title": "param",
        "name": "tags",
        "lineNumber": 82
      },
      {
        "title": "param",
        "name": "rest",
        "lineNumber": 82,
        "type": {
          "type": "RestType"
        }
      },
      {
        "title": "param",
        "name": "tagsarray",
        "lineNumber": 3,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "An Array containing tags or strings. See example below.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 56,
                      "offset": 55
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 56,
                  "offset": 55
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 56,
              "offset": 55
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "param",
        "name": "validation",
        "lineNumber": 4,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The validation Array is optional (pass it if you use one)",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 58,
                      "offset": 57
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 58,
                  "offset": 57
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 58,
              "offset": 57
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Array"
        },
        "default": "[]"
      }
    ],
    "properties": [],
    "returns": [
      {
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "An array containing (validated) tags",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 37,
                      "offset": 36
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 37,
                  "offset": 36
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 37,
              "offset": 36
            }
          }
        },
        "title": "returns",
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      }
    ],
    "sees": [],
    "throws": [],
    "todos": [],
    "name": "createTags",
    "kind": "constant",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "createTags",
        "kind": "constant"
      }
    ],
    "namespace": "createTags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Property to bind a model to the input.\nIf the user changes the input value, the model updates, too.\nIf the user presses enter with an valid input,\na new tag is created with the value of this model.\nAfter creating the new tag, the model is cleared.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 5,
                  "column": 50,
                  "offset": 247
                },
                "indent": [
                  1,
                  1,
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 5,
              "column": 50,
              "offset": 247
            },
            "indent": [
              1,
              1,
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 5,
          "column": 50,
          "offset": 247
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Property to bind a model to the input.\nIf the user changes the input value, the model updates, too.\nIf the user presses enter with an valid input,\na new tag is created with the value of this model.\nAfter creating the new tag, the model is cleared.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "required",
        "description": null,
        "lineNumber": 7
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 8,
        "type": {
          "type": "NameExpression",
          "name": "String"
        }
      },
      {
        "title": "model",
        "description": null,
        "lineNumber": 9
      },
      {
        "title": "default",
        "description": "''",
        "lineNumber": 10
      }
    ],
    "loc": {
      "start": {
        "line": 40,
        "column": 2
      },
      "end": {
        "line": 51,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 52,
          "column": 2
        },
        "end": {
          "line": 56,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "String"
    },
    "name": "value",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "value",
        "scope": "static"
      }
    ],
    "namespace": ".value"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Pass an array containing objects like in the example below.\nThe properties 'style' and 'class' are optional. Of course it is possible to add custom\nproperties to a tag object. vue-tags-input won't change the key and value.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 75,
                  "offset": 222
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 75,
              "offset": 222
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 75,
          "offset": 222
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Pass an array containing objects like in the example below.\nThe properties 'style' and 'class' are optional. Of course it is possible to add custom\nproperties to a tag object. vue-tags-input won't change the key and value.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "sync",
        "description": null,
        "lineNumber": 6
      },
      {
        "title": "default",
        "description": "[]",
        "lineNumber": 7
      },
      {
        "title": "example",
        "description": "{\n&emsp;text: 'My tag value', &#47;* The visible text on display *&#47;\n&emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;\n&emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;\n}",
        "lineNumber": 8
      }
    ],
    "loc": {
      "start": {
        "line": 57,
        "column": 2
      },
      "end": {
        "line": 71,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 72,
          "column": 2
        },
        "end": {
          "line": 76,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "{\n&emsp;text: 'My tag value', &#47;* The visible text on display *&#47;\n&emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;\n&emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;\n}"
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "tags",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "tags",
        "scope": "static"
      }
    ],
    "namespace": ".tags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Expects an array containing objects inside. The objects\ncan have the same properties as a tag object.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 46,
                  "offset": 101
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 46,
              "offset": 101
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 46,
          "offset": 101
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Expects an array containing objects inside. The objects\ncan have the same properties as a tag object.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[]",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 77,
        "column": 2
      },
      "end": {
        "line": 83,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 84,
          "column": 2
        },
        "end": {
          "line": 88,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "autocompleteItems",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteItems",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteItems"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines whether a tag is editable after creation or not.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 57,
                  "offset": 56
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 57,
              "offset": 56
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 57,
          "offset": 56
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines whether a tag is editable after creation or not.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 89,
        "column": 2
      },
      "end": {
        "line": 94,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 95,
          "column": 2
        },
        "end": {
          "line": 98,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "allowEditTags",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "allowEditTags",
        "scope": "static"
      }
    ],
    "namespace": ".allowEditTags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines if duplicate autocomplete items are filtered out from the view or not.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 79,
                  "offset": 78
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 79,
              "offset": 78
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 79,
          "offset": 78
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines if duplicate autocomplete items are filtered out from the view or not.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 99,
        "column": 2
      },
      "end": {
        "line": 104,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 105,
          "column": 2
        },
        "end": {
          "line": 108,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "autocompleteFilterDuplicates",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteFilterDuplicates",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteFilterDuplicates"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the user can add tags only via the autocomplete layer.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 69,
                  "offset": 68
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 69,
              "offset": 68
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 69,
          "offset": 68
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the user can add tags only via the autocomplete layer.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 109,
        "column": 2
      },
      "end": {
        "line": 114,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 115,
          "column": 2
        },
        "end": {
          "line": 118,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "addOnlyFromAutocomplete",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addOnlyFromAutocomplete",
        "scope": "static"
      }
    ],
    "namespace": ".addOnlyFromAutocomplete"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The minimum character length which is required\nuntil the autocomplete layer is shown. If set to 0,\nthen it'll be shown on focus.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 30,
                  "offset": 128
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 30,
              "offset": 128
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 30,
          "offset": 128
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The minimum character length which is required\nuntil the autocomplete layer is shown. If set to 0,\nthen it'll be shown on focus.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Number"
        }
      },
      {
        "title": "default",
        "description": "1",
        "lineNumber": 6
      }
    ],
    "loc": {
      "start": {
        "line": 119,
        "column": 2
      },
      "end": {
        "line": 126,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 127,
          "column": 2
        },
        "end": {
          "line": 130,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Number"
    },
    "name": "autocompleteMinLength",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteMinLength",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteMinLength"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the autocomplete layer is always shown, regardless if\nan input or an autocomplete items exists.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 42,
                  "offset": 109
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 42,
              "offset": 109
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 42,
          "offset": 109
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the autocomplete layer is always shown, regardless if\nan input or an autocomplete items exists.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 131,
        "column": 2
      },
      "end": {
        "line": 137,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 138,
          "column": 2
        },
        "end": {
          "line": 141,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "autocompleteAlwaysOpen",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteAlwaysOpen",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteAlwaysOpen"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Property to disable vue-tags-input.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 36,
                  "offset": 35
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 36,
              "offset": 35
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 36,
          "offset": 35
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Property to disable vue-tags-input.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 142,
        "column": 2
      },
      "end": {
        "line": 147,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 148,
          "column": 2
        },
        "end": {
          "line": 151,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "disabled",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "disabled",
        "scope": "static"
      }
    ],
    "namespace": ".disabled"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The placeholder text which is shown in the input, when it's empty.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 67,
                  "offset": 66
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 67,
              "offset": 66
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 67,
          "offset": 66
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The placeholder text which is shown in the input, when it's empty.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "String"
        }
      },
      {
        "title": "default",
        "description": "Add Tag",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 152,
        "column": 2
      },
      "end": {
        "line": 157,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 158,
          "column": 2
        },
        "end": {
          "line": 161,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "String"
    },
    "name": "placeholder",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "placeholder",
        "scope": "static"
      }
    ],
    "namespace": ".placeholder"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Custom trigger key codes can be registrated. If the user presses one of these,\na tag will be generated out of the input value. Can be either a numeric keyCode or the key\nas a string.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 13,
                  "offset": 182
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 13,
              "offset": 182
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 13,
          "offset": 182
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Custom trigger key codes can be registrated. If the user presses one of these,\na tag will be generated out of the input value. Can be either a numeric keyCode or the key\nas a string.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[13]",
        "lineNumber": 6
      },
      {
        "title": "example",
        "description": "add-on-key=\"[13, ':', ';']\"",
        "lineNumber": 7
      }
    ],
    "loc": {
      "start": {
        "line": 162,
        "column": 2
      },
      "end": {
        "line": 170,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 171,
          "column": 2
        },
        "end": {
          "line": 175,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "add-on-key=\"[13, ':', ';']\""
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "addOnKey",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addOnKey",
        "scope": "static"
      }
    ],
    "namespace": ".addOnKey"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Custom trigger key codes can be registrated. If the user edits a tag\nand presses one of these, the edited tag will be saved.\nCan be either a numeric keyCode or the key as a string.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 56,
                  "offset": 180
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 56,
              "offset": 180
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 56,
          "offset": 180
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Custom trigger key codes can be registrated. If the user edits a tag\nand presses one of these, the edited tag will be saved.\nCan be either a numeric keyCode or the key as a string.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[13]",
        "lineNumber": 6
      },
      {
        "title": "example",
        "description": "save-on-key=\"[13, ':', ';']\"",
        "lineNumber": 7
      }
    ],
    "loc": {
      "start": {
        "line": 176,
        "column": 2
      },
      "end": {
        "line": 184,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 185,
          "column": 2
        },
        "end": {
          "line": 189,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "save-on-key=\"[13, ':', ';']\""
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "saveOnKey",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "saveOnKey",
        "scope": "static"
      }
    ],
    "namespace": ".saveOnKey"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The maximum amount the tags array is allowed to hold.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 54,
                  "offset": 53
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 54,
              "offset": 53
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 54,
          "offset": 53
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The maximum amount the tags array is allowed to hold.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Number"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 190,
        "column": 2
      },
      "end": {
        "line": 194,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 195,
          "column": 2
        },
        "end": {
          "line": 197,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Number"
    },
    "name": "maxTags",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "maxTags",
        "scope": "static"
      }
    ],
    "namespace": ".maxTags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The maximum amount of characters the input is allowed to hold.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 63,
                  "offset": 62
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 63,
              "offset": 62
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 63,
          "offset": 62
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The maximum amount of characters the input is allowed to hold.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Number"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 198,
        "column": 2
      },
      "end": {
        "line": 202,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 203,
          "column": 2
        },
        "end": {
          "line": 205,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Number"
    },
    "name": "maxlength",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "maxlength",
        "scope": "static"
      }
    ],
    "namespace": ".maxlength"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Pass an array containing objects like in the example below.\nThe property 'classes' will be added as css classes, if the property 'rule' matches the text\nof a tag, an autocomplete item or the input. The property 'rule' can be type of\nRegExp or function. If the property 'disableAdd' is 'true', the item can't be added\nto the tags array, if the appropriated rule matches.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 5,
                  "column": 53,
                  "offset": 369
                },
                "indent": [
                  1,
                  1,
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 5,
              "column": 53,
              "offset": 369
            },
            "indent": [
              1,
              1,
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 5,
          "column": 53,
          "offset": 369
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Pass an array containing objects like in the example below.\nThe property 'classes' will be added as css classes, if the property 'rule' matches the text\nof a tag, an autocomplete item or the input. The property 'rule' can be type of\nRegExp or function. If the property 'disableAdd' is 'true', the item can't be added\nto the tags array, if the appropriated rule matches.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 7,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[]",
        "lineNumber": 8
      },
      {
        "title": "example",
        "description": "{\n&ensp;classes: 'class', &#47;* css class *&#47;\n&ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;\n}, {\n&ensp;classes: 'no-braces', &#47;* css class *&#47;\n&ensp;rule(text) { &#47;* function with text as param *&#47;\n&ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;\n&ensp;},\n&ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,\n},",
        "lineNumber": 9
      }
    ],
    "loc": {
      "start": {
        "line": 206,
        "column": 2
      },
      "end": {
        "line": 226,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 227,
          "column": 2
        },
        "end": {
          "line": 257,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "{\n&ensp;classes: 'class', &#47;* css class *&#47;\n&ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;\n}, {\n&ensp;classes: 'no-braces', &#47;* css class *&#47;\n&ensp;rule(text) { &#47;* function with text as param *&#47;\n&ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;\n&ensp;},\n&ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,\n},"
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "validation",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "validation",
        "scope": "static"
      }
    ],
    "namespace": ".validation"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines the characters which splits a text into different pieces,\nto generate tags out of this pieces.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 37,
                  "offset": 102
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 37,
              "offset": 102
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 37,
          "offset": 102
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines the characters which splits a text into different pieces,\nto generate tags out of this pieces.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[';']",
        "lineNumber": 5
      },
      {
        "title": "example",
        "description": "separators: [';', ',']\ninput: some; user input, has random; commas, an,d semicolons\nwill split into: some - user input - has random - commas - an - d semicolons",
        "lineNumber": 6
      }
    ],
    "loc": {
      "start": {
        "line": 258,
        "column": 2
      },
      "end": {
        "line": 268,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 269,
          "column": 2
        },
        "end": {
          "line": 279,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "separators: [';', ',']\ninput: some; user input, has random; commas, an,d semicolons\nwill split into: some - user input - has random - commas - an - d semicolons"
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "separators",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "separators",
        "scope": "static"
      }
    ],
    "namespace": ".separators"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the user can't add or save a tag,\nif another exists, with the same text value.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 45,
                  "offset": 92
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 45,
              "offset": 92
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 45,
          "offset": 92
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the user can't add or save a tag,\nif another exists, with the same text value.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 280,
        "column": 2
      },
      "end": {
        "line": 286,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 287,
          "column": 2
        },
        "end": {
          "line": 290,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "avoidAddingDuplicates",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "avoidAddingDuplicates",
        "scope": "static"
      }
    ],
    "namespace": ".avoidAddingDuplicates"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If the input holds a value and loses the focus,\na tag will be generated out of this value, if possible.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 56,
                  "offset": 103
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 56,
              "offset": 103
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 56,
          "offset": 103
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If the input holds a value and loses the focus,\na tag will be generated out of this value, if possible.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 291,
        "column": 2
      },
      "end": {
        "line": 297,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 298,
          "column": 2
        },
        "end": {
          "line": 301,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "addOnBlur",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addOnBlur",
        "scope": "static"
      }
    ],
    "namespace": ".addOnBlur"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Custom function to detect duplicates. If the function returns 'true',\nthe tag will be marked as duplicate.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 37,
                  "offset": 106
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 37,
              "offset": 106
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 37,
          "offset": 106
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Custom function to detect duplicates. If the function returns 'true',\nthe tag will be marked as duplicate.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Function"
        }
      },
      {
        "title": "param",
        "description": "The Array of tags minus the one which is edited/created.",
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        },
        "name": "tagsarray"
      },
      {
        "title": "param",
        "description": "The tag which is edited or should be added to the tags array.",
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        },
        "name": "tag"
      },
      {
        "title": "example",
        "description": "// The duplicate function to recreate the default behaviour, would look like this:\nisDuplicate(tags, tag) {\n&ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;\n}",
        "lineNumber": 7
      }
    ],
    "loc": {
      "start": {
        "line": 302,
        "column": 2
      },
      "end": {
        "line": 314,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 315,
          "column": 2
        },
        "end": {
          "line": 318,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "// The duplicate function to recreate the default behaviour, would look like this:\nisDuplicate(tags, tag) {\n&ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;\n}"
      }
    ],
    "params": [
      {
        "title": "param",
        "name": "tagsarray",
        "lineNumber": 5,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The Array of tags minus the one which is edited/created.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 57,
                      "offset": 56
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 57,
                  "offset": 56
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 57,
              "offset": 56
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "param",
        "name": "tag",
        "lineNumber": 6,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The tag which is edited or should be added to the tags array.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 62,
                      "offset": 61
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 62,
                  "offset": 61
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 62,
              "offset": 61
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Function"
    },
    "name": "isDuplicate",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "isDuplicate",
        "scope": "static"
      }
    ],
    "namespace": ".isDuplicate"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the user can paste into the input element and\nvue-tags-input will create tags out of the incoming text.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 58,
                  "offset": 117
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 58,
              "offset": 117
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 58,
          "offset": 117
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the user can paste into the input element and\nvue-tags-input will create tags out of the incoming text.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 319,
        "column": 2
      },
      "end": {
        "line": 325,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 326,
          "column": 2
        },
        "end": {
          "line": 329,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "addFromPaste",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addFromPaste",
        "scope": "static"
      }
    ],
    "namespace": ".addFromPaste"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines if it's possible to delete tags by pressing backspace.\nIf so and the user wants to delete a tag,\nthe tag gets the css class 'deletion-mark' for 1 second.\nIf the user presses backspace again in that time period,\nthe tag is removed from the tags array and the view.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 5,
                  "column": 53,
                  "offset": 271
                },
                "indent": [
                  1,
                  1,
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 5,
              "column": 53,
              "offset": 271
            },
            "indent": [
              1,
              1,
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 5,
          "column": 53,
          "offset": 271
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines if it's possible to delete tags by pressing backspace.\nIf so and the user wants to delete a tag,\nthe tag gets the css class 'deletion-mark' for 1 second.\nIf the user presses backspace again in that time period,\nthe tag is removed from the tags array and the view.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 7,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 8
      }
    ],
    "loc": {
      "start": {
        "line": 330,
        "column": 2
      },
      "end": {
        "line": 339,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 340,
          "column": 2
        },
        "end": {
          "line": 343,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "deleteOnBackspace",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "deleteOnBackspace",
        "scope": "static"
      }
    ],
    "namespace": ".deleteOnBackspace"
  }
];